import { PRODUCT_URL } from "../../../Utils/constService";
import api from "../../../../BasicComponent/Service/api";

export const fetchProduct = () => {
  return api.get(PRODUCT_URL);
};

export const postProduct = (data) => {
  return api.post(PRODUCT_URL, data);
};

export const putProduct = (productId, data) => {
  return api.put(`${PRODUCT_URL}/${productId}`, data);
};

export const deleteProduct = (productId) => {
  return api.delete(`${PRODUCT_URL}/${productId}`);
};
